import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { ASSETS } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { LogOut, User, Lock } from "lucide-react";
import GoogleLoginButton from "@/components/GoogleLoginButton";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [periodo, setPeriodo] = useState(null);

  useEffect(() => {
    axios.get(`${API}/config/periodo-inscricoes`)
      .then((r) => setPeriodo(r.data))
      .catch(() => {});
  }, []);

  const aberto = !periodo || periodo.status?.aberto;
  return (
    <header className="bg-white border-b border-slate-200" data-testid="site-header">
      <div className="govbr-stripe" />
      <div className="max-w-7xl mx-auto px-4 py-3 flex flex-wrap items-center gap-4">
        <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
          <img src={ASSETS.brasao} alt="Brasão da Prefeitura" className="h-12 w-auto" />
          <div className="leading-tight hidden sm:block">
            <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">Prefeitura Municipal de</div>
            <div className="text-base font-black text-[#083CA6]">GRAJAÚ – MA</div>
            <div className="text-[11px] text-slate-500">Secretaria Municipal de Habitação</div>
          </div>
        </Link>
        <div className="ml-auto flex items-center gap-2">
          <img src={ASSETS.logoMcmv} alt="Minha Casa Minha Vida" className="h-12 w-12 rounded" />
          <div className="hidden md:block leading-tight">
            <div className="text-xs text-slate-500">Programa</div>
            <div className="text-sm font-bold text-[#083CA6]">Minha Casa Minha Vida 2026</div>
          </div>
        </div>
        <nav className="basis-full md:basis-auto md:ml-4 flex items-center gap-2 flex-wrap">
          {aberto ? (
            <Link to="/inscricao"><Button variant="ghost" size="sm" data-testid="nav-inscricao">Fazer Inscrição</Button></Link>
          ) : (
            <Button variant="ghost" size="sm" disabled aria-disabled="true" title="Inscrições estão desativadas no momento" className="text-slate-400 cursor-not-allowed" data-testid="nav-inscricao-bloqueado">
              <Lock className="w-3.5 h-3.5 mr-1" />Inscrições Desativadas
            </Button>
          )}
          <Link to="/consultar"><Button variant="ghost" size="sm" data-testid="nav-consultar">Consultar Protocolo</Button></Link>
          {!user ? (
            <>
              <GoogleLoginButton
                size="sm"
                variant="outline"
                label="Google"
                dataTestId="nav-google-login"
                className="hidden sm:inline-flex"
              />
              <Link to="/login"><Button size="sm" className="bg-[#083CA6] hover:bg-[#062f85]" data-testid="nav-login">Entrar</Button></Link>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate(user.role === "cidadao" ? "/area-cidadao" : "/admin")} data-testid="nav-painel">
                <User className="w-4 h-4 mr-1" />{user.nome.split(" ")[0]}
              </Button>
              <Button variant="outline" size="sm" onClick={async () => { await logout(); navigate("/"); }} data-testid="nav-logout">
                <LogOut className="w-4 h-4 mr-1" />Sair
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
